import React from 'react';
import {API_KEY, API_PREFIX} from "../Configuration"
import {Loading} from "./Loading"
import $ from 'jquery';
import {PostBrief} from "./PostBrief"
import QueueAnim from 'rc-queue-anim';

export class PostList extends React.Component {
  state = {
    data: null
  };

  componentDidMount() {
    $.getJSON({
      url: `${API_PREFIX}/get_recent_posts_brief`,
      method: 'GET',
      data: $.param({APIKEY: API_KEY})
    }).then((json) => {
      console.log(json);
      this.setState({data: json});
    }, (err) => {
      console.log('failed');
      console.log(err.statusText);
      this.setState({data: []});
    });
  }


  render() {
    const data = this.state.data;
    if (!data) {
      return <Loading/>;
    };

    const comps = data.map( p => <PostBrief key={p.id} post={p}/> );
    return (
      <QueueAnim delay={300} type={['right', 'left']}>
        {comps}
      </QueueAnim>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PostList.js